import { useSelector } from 'react-redux';
import I18n from 'i18n-js';

import IconWithNotifications from '~/components/IconWithNotifications';

import useDailyQuestsCountSelector from '~/redux/hooks/useDailyQuestsCountSelector';
import { loggedSelector } from '~/redux/selectors';
import { DAILY_PATH } from '~/routes/paths';

import NavigationLink from '../NavigationLink';

import styles from './DailyBoostButton.module.scss';

export default function DailyBoostButton(): JSX.Element {
  const loggedIn = useSelector(loggedSelector);
  const count = useDailyQuestsCountSelector();
  const text = I18n.t('TopNav_daily_boost');
  return (
    <NavigationLink
      to={DAILY_PATH}
      className={styles.dailyBoostButton}
      childrentext={text}
    >
      <IconWithNotifications
        showBadge={loggedIn ? Boolean(count) : false}
        notificationClassName={styles.dailyTaskCounter}
      >
        {text}
      </IconWithNotifications>
    </NavigationLink>
  );
}
